import React, {useEffect, useState} from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import exportingModule from "highcharts/modules/exporting";
import {INTERACTION_COLOR_HIGHCHART} from "../utils/colorMap.js"
import {processClick} from "../utils/allinteraction";

exportingModule(Highcharts);

export default function Pie({mainData, results, firstRowDivHeight, onNestedRowClick, sortInteractionTypeOnClick}) {

    //,Res. Name 1,Res. Number 1,Chain 1,Res. Name 2,Res. Number 2,Chain 2,Type of Interactions
    const [options, setOptions] = useState([]);

    const handleClick = (record) => {
        const interactionType = record;

        sortInteractionTypeOnClick(interactionType);

        processClick(interactionType, results).then((data) => {
            data.forEach(row => onNestedRowClick(row, interactionType, false));
            document.getElementById("molstar").scrollIntoView({behavior: 'smooth'});
        });
    };

    useEffect(() => {
        const data = {};

        mainData.forEach(row => {
            const interactions = row[7].split(";");
            interactions.forEach(interaction => {
                interaction = interaction.trim();
                interaction = interaction.replace('*', '');
                if (interaction) {
                    if (data[interaction]) {
                        data[interaction].y++;
                    } else {
                        data[interaction] = {
                            'name': interaction,
                            sliced: true,
                            y: 1,
                            color: INTERACTION_COLOR_HIGHCHART[interaction]
                        };
                    }
                }
            });
        });

        const options = {
            chart: {
                type: 'pie',
                height: firstRowDivHeight
            },
            title: {
                text: 'Atomic Interactions <br/> Distribution'
            },
            tooltip: {
                formatter: function () {
                    return `<strong>${this.point.name}</strong>`;
                },
            },
            subtitle: {
                text:
                    ''
            },
            plotOptions: {
                pie: {
                    dataLabels: {
                        format: '{point.name} ({point.percentage:.1f}%)',
                        style: {
                            fontSize: '0.8em',
                            color: 'black'
                        }
                    },
                    point: {
                        events: {
                            click: function () {
                                handleClick(this.name);
                            }
                        }
                    }
                }
            },
            series: [
                {
                    name: 'Percentage',
                    colorByPoint: true,
                    data: Object.values(data).sort((a, b) => a.name.localeCompare(b.name)),
                    animation: false
                }
            ],
        }

        setOptions(options);

    }, [mainData, firstRowDivHeight]);

    return (
        <div style={{paddingLeft: '40px', paddingRight: '40px'}}>
            <HighchartsReact highcharts={Highcharts} options={options}/>
        </div>
    )
}